import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/app/search/[category]/error.tsx");
